import { useState } from "react";

import { ApiClientError } from "../api/client.js";
import { useStore } from "../store.js";

export function Login() {
  const login = useStore((state) => state.login);
  const register = useStore((state) => state.register);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [mode, setMode] = useState<"login" | "register">("login");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(event: React.FormEvent) {
    event.preventDefault();
    setError(null);
    setBusy(true);
    try {
      if (mode === "login") {
        await login(email, password);
      } else {
        await register(email, password);
      }
    } catch (caught) {
      const message =
        caught instanceof ApiClientError
          ? caught.message
          : "Something went wrong. Please try again.";
      setError(message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="flex h-full items-center justify-center p-6">
      <form
        onSubmit={submit}
        className="w-full max-w-sm rounded-2xl border border-node-border bg-node-bg p-8 shadow-xl"
      >
        <div className="mb-1 flex items-center gap-3">
          <img src="/logo.png" alt="" className="h-9 w-9" />
          <h1 className="text-2xl font-semibold text-ink">Vulpari</h1>
        </div>
        <p className="mb-6 text-sm text-ink-muted">
          {mode === "login"
            ? "Sign in to your canvas."
            : "Create the owner account for this instance."}
        </p>

        <label className="mb-1 block text-sm text-ink-muted" htmlFor="email">
          Email
        </label>
        <input
          id="email"
          type="email"
          autoComplete="email"
          value={email}
          onChange={(event) => setEmail(event.target.value)}
          required
          className="mb-4 w-full rounded-lg border border-node-border bg-canvas px-3 py-2 text-ink outline-none focus:border-accent"
        />

        <label className="mb-1 block text-sm text-ink-muted" htmlFor="password">
          Password
        </label>
        <input
          id="password"
          type="password"
          autoComplete={mode === "login" ? "current-password" : "new-password"}
          value={password}
          onChange={(event) => setPassword(event.target.value)}
          required
          minLength={8}
          className="mb-6 w-full rounded-lg border border-node-border bg-canvas px-3 py-2 text-ink outline-none focus:border-accent"
        />

        {error ? <p className="mb-4 text-sm text-warning">{error}</p> : null}

        <button
          type="submit"
          disabled={busy}
          className="w-full rounded-lg bg-accent px-4 py-2 font-medium text-canvas transition-opacity hover:opacity-90 disabled:opacity-60"
        >
          {busy ? "Please wait..." : mode === "login" ? "Sign in" : "Create account"}
        </button>

        <button
          type="button"
          onClick={() => {
            setMode(mode === "login" ? "register" : "login");
            setError(null);
          }}
          className="mt-4 w-full text-center text-sm text-ink-muted underline-offset-2 hover:underline"
        >
          {mode === "login" ? "Set up a new instance" : "I already have an account"}
        </button>
      </form>
    </div>
  );
}
